import { render, staticRenderFns } from "./GoodsCategory.vue?vue&type=template&id=0b789130&scoped=true&"
import script from "./GoodsCategory.vue?vue&type=script&lang=js&"
export * from "./GoodsCategory.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCategory.vue?vue&type=style&index=0&id=0b789130&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b789130",
  null
  
)

export default component.exports